var _DiplomaListSkeleton;
import cn from "classnames";
import { Container } from "@crehana/ui";
import { useDiplomasTranslation } from "../hooks/useDiplomasTranslation";
import DiplomaListSkeleton from "./DiplomaListSkeleton";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var DiplomasSkeleton = function DiplomasSkeleton(_ref) {
  var _ref$className = _ref.className,
    className = _ref$className === void 0 ? 'mb-40' : _ref$className,
    isDark = _ref.isDark;
  var _useDiplomasTranslati = useDiplomasTranslation(),
    t = _useDiplomasTranslati.t;
  return /*#__PURE__*/_jsx("div", {
    className: cn('w-full', className),
    children: /*#__PURE__*/_jsxs(Container, {
      children: [/*#__PURE__*/_jsx("p", {
        className: cn('font-h4 mb-24', isDark ? 'text-white' : 'text-base-main'),
        children: t('DIPLOMAS_TITLE')
      }), _DiplomaListSkeleton || (_DiplomaListSkeleton = /*#__PURE__*/_jsx(DiplomaListSkeleton, {}))]
    })
  });
};
export default DiplomasSkeleton;